<div class="view-footer-container">
  <div class="flags-container d-flex">
    <ng-container *ngFor="let item of model.flags$()">
      <mat-checkbox [(ngModel)]="item.value"
                    (ngModelChange)="flagChanged(item.name, item.value)"
                    [attr.data-link-ga-node]="item.name">
        {{item.label | translate}}
      </mat-checkbox>
    </ng-container>
  </div>
  <div class="actions-container d-flex">
    <ng-container *ngFor="let item of model.actions$()">
      <a class="action-item" [attr.data-link-ga-node]="item.name" (click)="actionClicked(item.name)">
        {{item.label | translate}}
      </a>
    </ng-container>
  </div>
</div>
